<!--The content below is only a placeholder and can be replaced.-->
<div>
    <div class="sidebar-top">
        <app-siderbar-top></app-siderbar-top>
    </div>
    <div class="container page-wapper-container w-100">
        <div class="sidebar-left">
            <app-sidebar-left></app-sidebar-left>
        </div>
        <div class="body-outlet">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>